import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SectionsService } from '../../services/sections.service';
import { ENDPOINTS } from '../constants/url.constants';
import { formatUrl } from '../utils/format-url-util';
import { GlobalErrorHandlerService } from './global-error-handler.service';
import { HttpRequestService } from './http-request.service';
import { NotificationService } from './notification.service';
import { SharedDataService } from './shared-data-service';

@Injectable({
  providedIn: 'root',
})
export class ListService {
  private apiUrl = environment.apiUrl;
  applicationDataSub = new Subject();

  constructor(
    private httpService: HttpClient,
    private http: HttpRequestService,
    private sharedService: SharedDataService,
    private sectionService: SectionsService,
    private errorHandler: GlobalErrorHandlerService,
    private notificationService: NotificationService
  ) {}
  //constructor(private http: HttpClient) { }

  getListConfigData(code: string, state: string, listpage: string) {
    return require(`../../../assets/data/programs/${state}/${code}/list_pages/${listpage}.json`);
  }

  setApplicationData(data: any) {
    this.applicationDataSub.next(data);
  }

  sendNotification(from: string, requestPayload: any): Observable<any> {
    const url = from === 'details' ? ENDPOINTS.SEND_NOTIFICATION : ENDPOINTS.SEND_NOTIFICATION_WITH_IDS;
    return this.http.post(url, requestPayload, true);
  }
}
